import { Validators } from '@angular/forms';
import { Formulario } from './../interface/fomulario';

export class Direccion implements Formulario {
    createFormulario(): any[] {
        const form = [{reference: 'street_type', element: 'select', name: 'tipoVia',
        label: 'Tipo de vía*', options: [], referenceName: 'name', referenceValue: 'name', validations: [Validators.required]},
        {element: 'text', name: 'address', label: 'Dirección*', validations: [Validators.required]},
        {element: 'number', name: 'zip', label: 'Código postal*', validations: [Validators.required]},
        {element: 'text', name: 'municipality', label: 'Municipio', validations: []}
    ];
        return form;
    }

}
